<template>
  <div class="znty-step1-layer">
    <div class="step1-content" v-if="statue == 0">
      <div class="step1-title">
        风险测评问卷
      </div>
      <div class="step1-desc">
        请您回答以下问题，帮助智能投顾助手了解风险承受能力和偏好。
      </div>
      <div class="step1-question">
        <div class="question-section">
          <div class="section-title">一、基础信息</div>
          <div v-for="(question, index) in basicQuestions" :key="index" class="question-item">
            <div class="question-text">{{ index + 1 }}. {{ question.text }}</div>
            <div class="options-container">
              <div v-for="(option, optIndex) in question.options" :key="optIndex" class="option-item"
                   :class="{ 'selected': selectedAnswers[question.id] === option.value }"
                   @click="selectOption(question.id, option.value, question.type)">
                <div class="option-radio">
                  <div class="radio-circle" :class="{ 'selected': selectedAnswers[question.id] === option.value }">
                    <div class="radio-dot" v-if="selectedAnswers[question.id] === option.value"></div>
                  </div>
                </div>
                <div class="option-text">{{ option.label }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="question-section">
          <div class="section-title">二、财务现状与流动性</div>
          <div v-for="(question, index) in financeQuestions" :key="index" class="question-item">
            <div class="question-text">{{ index + 4 }}. {{ question.text }}</div>
            <div class="options-container">
              <!-- 单选题 -->
              <div v-if="question.type === 'single'">
                <div v-for="(option, optIndex) in question.options" :key="optIndex" class="option-item"
                     :class="{ 'selected': selectedAnswers[question.id] === option.value }"
                     @click="selectOption(question.id, option.value, question.type)">
                  <div class="option-radio">
                    <div class="radio-circle" :class="{ 'selected': selectedAnswers[question.id] === option.value }">
                      <div class="radio-dot" v-if="selectedAnswers[question.id] === option.value"></div>
                    </div>
                  </div>
                  <div class="option-text">{{ option.label }}</div>
                </div>
              </div>

              <!-- 多选题 -->
              <div v-if="question.type === 'multiple'">
                <div v-for="(option, optIndex) in question.options" :key="optIndex" class="option-item"
                     :class="{ 'selected': isOptionSelected(question.id, option.value) }"
                     @click="toggleMultipleOption(question.id, option.value)">
                  <div class="option-checkbox">
                    <div class="checkbox-square" :class="{ 'selected': isOptionSelected(question.id, option.value) }">
                      <div class="checkbox-check" v-if="isOptionSelected(question.id, option.value)">✓</div>
                    </div>
                  </div>
                  <div class="option-text">{{ option.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 开始测评按钮 -->
        <div class="submit-section">
          <button class="submit-btn" @click="startEvaluation">开始测评</button>
        </div>
      </div>
    </div>

    <!--测评结果-->
    <div class="cepingjieguo" v-if="statue == 2">
      <div class="cepingjieguo-title">
        您的风险类型属于：
      </div>
      <div class="cepingjieguo-desc">
        <div class="shield-container">
          <img :src="require('@/assets/imgs/case/image_307.png')" alt="风险类型" class="shield-icon" />
          <!-- <div class="shield-bg">
            <img :src="require('@/assets/imgs/case/image_307.png')" alt="风险类型" class="shield-icon" />
          </div> -->
        </div>
        <div class="risk-type-name">极端保险型</div>
        <div class="risk-features">
          核心特性：低亏损容忍+高流动性需求+短期目标（1年-3年）
        </div>
      </div>
      <div class="cepingjieguo-btn">
        <button class="submit-btn primary-btn" @click="seeRecommend">查看投资推荐</button>
        <div class="reset-link" @click="resetEvaluation">我要重新测评</div>
      </div>
    </div>

    <div class="dd-inner" v-show="loading">
      <zdyloading style="width: 200px;" ref="zdyloading" :isShowLoading="loading" loadingTxt="智能投顾正在分析你的风险类型，请稍等...">
      </zdyloading>
    </div>

  </div>
</template>

<script>
import Zdyloading from '@/components/Zdyloading.vue'
export default {
  name: '',
  components: { Zdyloading },
  props: {},
  data () {
    return {
      statue: 0,//0：未测评，1：测评中，2：测评完成
      // 基础信息问题
      basicQuestions: [
        {
          id: 'age',
          text: '您的年龄属于哪个范围？',
          type: 'single',
          options: [
            { label: '30-40岁', value: '30-40' },
            { label: '40-50岁', value: '40-50' },
            { label: '50-60岁', value: '50-60' },
            { label: '60岁以上', value: '60+' }
          ]
        },
        {
          id: 'assets',
          text: '您的家庭可投资资产规模（不含房产）？',
          type: 'single',
          options: [
            { label: '1000万-5000万', value: '1000-5000' },
            { label: '5000万-1亿', value: '5000-10000' },
            { label: '1亿以上', value: '10000+' }
          ]
        },
        {
          id: 'income',
          text: '您的财富主要来源是？',
          type: 'single',
          options: [
            { label: '企业经营', value: 'business' },
            { label: '投资收益', value: 'investment' },
            { label: '继承', value: 'inheritance' },
            { label: '专业服务（律师、医生）', value: 'professional' }
          ]
        }
      ],

      // 财务现状与流动性问题
      financeQuestions: [
        {
          id: 'liquidity',
          text: '您希望保留多少比例的资产作为紧急流动储备？',
          type: 'single',
          options: [
            { label: '< 10%', value: '<10' },
            { label: '10%-20%', value: '10-20' },
            { label: '20%-30%', value: '20-30' },
            { label: '无保留', value: 'none' }
          ]
        },
        {
          id: 'investments',
          text: '您目前的投资组合中，是否持有以下资产？（多选）',
          type: 'multiple',
          options: [
            { label: '股票/基金', value: 'stock' },
            { label: '私募股权', value: 'private' },
            { label: '海外资产', value: 'overseas' },
            { label: '加密货币', value: 'crypto' },
            { label: '艺术/红酒', value: 'art' }
          ]
        },
        {
          id: 'debt',
          text: '您的负债与资产比率约为？',
          type: 'single',
          options: [
            { label: '< 20%', value: '<20' },
            { label: '20%-50%', value: '20-50' },
            { label: '> 50%', value: '>50' }
          ]
        }
      ],

      // 存储用户的答案
      selectedAnswers: {},

      loading: false,
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  methods: {
    // 选择单选题选项
    selectOption (questionId, optionValue, questionType) {
      if (questionType === 'single') {
        this.$set(this.selectedAnswers, questionId, optionValue);
      }
    },

    // 切换多选题选项
    toggleMultipleOption (questionId, optionValue) {
      if (!this.selectedAnswers[questionId]) {
        this.$set(this.selectedAnswers, questionId, []);
      }

      const index = this.selectedAnswers[questionId].indexOf(optionValue);
      if (index > -1) {
        // 如果已选中，则取消选中
        this.selectedAnswers[questionId].splice(index, 1);
      } else {
        // 如果未选中，则添加选中
        this.selectedAnswers[questionId].push(optionValue);
      }
    },

    // 检查多选题选项是否被选中
    isOptionSelected (questionId, optionValue) {
      return this.selectedAnswers[questionId] &&
        this.selectedAnswers[questionId].indexOf(optionValue) > -1;
    },

    // 开始测评
    startEvaluation () {
      // 这里可以添加表单验证逻辑
      console.log('开始测评，用户答案：', this.selectedAnswers);
      // 这里可以调用API提交答案，或者跳转到下一个步骤
      // 例如：this.$emit('nextStep', this.selectedAnswers);
      this.loading = true
      setTimeout(() => {
        this.statue = 2
        this.loading = false
      }, 2000)
    },

    //查看投资推荐
    seeRecommend () {
      // 跳转到第二步 Step2
      if (this.statue === 2) {
        this.$emit('nextStep', 'Step2')
      }
    },

    //重新测评
    resetEvaluation () {
      this.statue = 0
      this.selectedAnswers = {}
    }

  }
}
</script>

<style scoped lang="less">
.znty-step1-layer {
  height: 100%;
  color: #fff;
  padding: 20px;
  overflow: auto;
}

.step1-content {
  max-width: 1366px;
  margin: 0 auto;
}

.step1-title {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
  color: #fff;
}

.step1-desc {
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
  color: #8892b0;
}

.question-section {
  margin-bottom: 40px;
  // background: rgba(17, 34, 64, 0.7);
  border-radius: 12px;
  padding: 24px;
  backdrop-filter: blur(10px);
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  // color: #1549f3;
  color: #fff;
}

.question-item {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(136, 146, 176, 0.1);

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}

.question-text {
  font-size: 16px;
  margin-bottom: 16px;
  color: #ccd6f6;
}

.options-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.option-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: rgba(45, 57, 82, 0.5);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 20px;
  margin-bottom: 10px;

  &:hover {
    background: rgba(65, 80, 114, 0.5);
  }

  &.selected {
    background: rgba(21, 73, 243, 0.15);
    border: 1px solid rgba(21, 73, 243, 0.5);
  }
}

.option-radio,
.option-checkbox {
  margin-right: 10px;
}

.radio-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #8892b0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &.selected {
    border-color: #1549f3;
  }
}

.radio-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #1549f3;
}

.checkbox-square {
  width: 20px;
  height: 20px;
  border: 2px solid #8892b0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 14px;

  &.selected {
    background: #1549f3;
    border-color: #1549f3;
    color: #0a192f;
  }
}

.option-text {
  font-size: 14px;
  color: #ccd6f6;
}

.submit-section {
  text-align: center;
  margin-top: 40px;
}

.submit-btn {
  padding: 12px 40px;
  font-size: 18px;
  font-weight: bold;
  background: #1549f3;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #1549f3;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &.primary-btn {
    background: #1549f3;
    box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);
  }
}

// 测评结果样式
.cepingjieguo {
  text-align: center;
  // padding: 40px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cepingjieguo-title {
  font-size: 24px;
  color: #fff;
  margin-bottom: 40px;
  font-weight: 500;
}

.cepingjieguo-desc {
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.shield-container {
  margin-bottom: 20px;

  img {
    width: 361px;
    height: 229px;
    object-fit: contain;
    animation: float 3s ease-in-out infinite;
  }
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(0px);
  }
}

.risk-type-name {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.risk-features {
  font-size: 16px;
  color: #4568F7;
  line-height: 1.6;
  padding: 0 20px;
  text-align: center;
}

.cepingjieguo-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.reset-link {
  color: #8a99c0;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  transition: all 0.3s ease;

  &:hover {
    color: #1549f3;
    transform: translateY(-1px);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .options-container {
    flex-direction: column;
  }

  .option-item {
    margin-right: 0;
    width: 100%;
  }

  .section-title {
    font-size: 18px;
  }

  .question-text {
    font-size: 14px;
  }
}

.dd-inner {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 6, 36, 0.6);

  /deep/ .loading-text {
    color: #fff;
  }
}
</style>
